import jstz from "jstz";
import moment from "moment-timezone";
import Raven from "raven-js";
import { find, some } from "lodash";
import { reactLocalStorage } from "reactjs-localstorage";
import { getRequest } from "../api/ApiService";

import Auth from "routes/Auth";

export const hideNotFinishedParts = () => {
  return process.env.REACT_APP_HIDE_NOT_FINISHED_PART &&
    process.env.REACT_APP_HIDE_NOT_FINISHED_PART.toLowerCase() === "true"
    ? true
    : false;
};

export const detectMobile = () => (window.MobileDetect.phone() ? true : false);

export const getLogoStyle = isMobile =>
  isMobile
    ? {
      width: "100%",
      maxWidth: 400,
      marginTop: "-5vh"
    }
    : {
      height: 250
    };

export function validateEmail(email) {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function numericSuffix(num) {
  const j = num % 10;
  const k = num % 100;

  if (j === 1 && k !== 11) {
    return `${num}st`;
  } else if (j === 2 && k !== 12) {
    return `${num}nd`;
  } else if (j === 3 && k !== 13) {
    return `${num}rd`;
  }

  return `${num}th`;
}

export function decimalsRound(value, decimals) {
  return Number(
    Math.round(Number(value + "e" + decimals)) + "e-" + decimals
  ).toFixed(decimals);
}

export function ucfirst(str) {
  const firstPart = str.charAt(0).toUpperCase();
  const secondPart = str.substr(1, str.length - 1);

  return firstPart + secondPart;
}

export function addUserSpecificParams(url) {
  const user = Auth.getUser();
  const user_id = user ? user.id : 0;
  const username = user ? user.username : "";

  if (user_id > 0 && username !== "") {
    return `${url}?user_id=${user_id}&name=${username}`;
  }

  return url;
}

export function hexToRgba(hex, alpha) {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    let c = hex.substring(1).split("");

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    const rgb = Number("0x" + c.join(""));
    const r = (rgb >> 16) & 255;
    const g = (rgb >> 8) & 255;
    const b = rgb & 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return hex;
}

export function logError(err, classname, method) {
  Raven.captureException(err, {
    logger: classname,
    extra: {
      body: err.response && err.response.body,
      method: method
    }
  });
}

export function getDateInCurrentTimezone(value) {
  const utc = moment.utc(value);
  const timezone = jstz.determine();
  return moment(utc)
    .tz(timezone.name())
    .valueOf();
}

export function showFlashingDot(
  rounds,
  current_round,
  round_in_url,
  has_access = true
) {
  if (has_access === false) {
    return false;
  }

  let round_number = current_round;
  if (round_in_url !== null && round_in_url !== current_round) {
    round_number = round_in_url;
  }

  const round = rounds.find(i => i.number === round_number);
  if (round) {
    return !round.is_finished;
  }

  return false;
}

export const roleToUrl = role =>
({
  CEO: "ceo",
  PD: "pd",
  PM: "pm",
  FI: "fn",
  OP: "op"
}[role] || "");

export const roleToUrlFull = role =>
({
  CEO: "ceo",
  PD: "product-development",
  PM: "product-marketing",
  FI: "finance",
  OP: "operations"
}[role] || "");

export const getFirstRoundId = () => {
  return new Promise((resolve, reject) => {
    getRequest(`${process.env.REACT_APP_API_URL}game/rounds/`).then(res => {
      const round = find(res.body, r => Number(r.number) === 1);

      if (round) {
        resolve(round.id);
      } else {
        reject("Cannot find first round object");
      }
      resolve(null);
    });
  });
};

export const setGetStartedShown = () => {
  const shown = JSON.parse(reactLocalStorage.get("get-started-shown", "[]"));

  return new Promise((resolve, reject) => {
    getFirstRoundId().then(firstRoundId => {
      reactLocalStorage.set(
        "get-started-shown",
        JSON.stringify([...shown, { firstRoundId, userId: Auth.getUserId() }])
      );

      resolve(true);
    });
  });
};

export const isGetStartedShown = () => {
  const shown = JSON.parse(reactLocalStorage.get("get-started-shown", "[]"));

  return new Promise((resolve, reject) => {
    getFirstRoundId().then(firstRoundId => {
      const found = find(
        shown,
        i => i.firstRoundId === firstRoundId && i.userId === Auth.getUserId()
      );

      resolve(found ? true : false);
    });
  });
};

export const isAccepted = items => some(items, item => item.accepted);

export const isDevelopment = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
};



// WEBPACK FOOTER //
// ./src/services/utils.js